const prefix = 'X-Therame-';
export const EXERCISE_UPLOAD_TOKEN = prefix + 'Exercise-Upload-Token';
export const X_ACCESS_TOKEN = 'x-access-token';
export const X_THERAME_API_VERSION = 'x-therame-api-version';
/** Names the Active office of the request (#1822). Lower case: Node lower-cases incoming headers. */
export const X_THERAME_OFFICE_ID = 'x-therame-office-id';
/**
 * Names the Caregiver entry a request acts through (#1841). A TAN session
 * refuses it like an unknown office (#1855).
 */
export const X_THERAME_CAREGIVER_ID = 'x-therame-caregiver-id';
/** Carries the call token of a TAN session (#1855); never sent together with a bearer. */
export const X_THERAME_CALL_SESSION = 'x-therame-call-session';
//# sourceMappingURL=custom-http-headers.js.map